import { mapCardFromCMS } from '@/components/molecules/ml-card/ml-card.cms';
import { OrCardsList } from './or-cards-list';
import { IOrCardsListCMSProps } from './or-card-list.types';
import { EAlignment } from '@/components/molecules/ml-header/ml-header.types';
import { SizesProvider } from '@/state/sizesProvider';

export const OrCardsListCMS = ({
  cards: cmsCards,
  heading_alignment = EAlignment.LEFT,
  heading_element,
  heading,
  top_spacing,
  bottom_spacing,
  _content_type_uid: contentType,
}: IOrCardsListCMSProps) => {
  if (!cmsCards) return;

  const parseCards = cmsCards.map((cmsCard) => mapCardFromCMS(cmsCard));
  const blogCenteringClasses = 'items-center justify-center';

  return (
    <SizesProvider contentType={contentType}>
      <OrCardsList
        cards={parseCards}
        alignment={heading_alignment}
        heading={heading}
        headingElement={heading_element?.select || 'h2'}
        topSpacing={top_spacing?.spacing_value}
        bottomSpacing={bottom_spacing?.spacing_value}
        topDivider={top_spacing?.divider}
        bottomDivider={bottom_spacing?.divider}
        wrapperClassName={blogCenteringClasses}
      />
    </SizesProvider>
  );
};
